(function () {
  'use strict';

  function openInNewTab(url) {
    if (!url || url === '#') return;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  function buildFormUrl(form) {
    var action = form.getAttribute('action');
    if (!action) return null;

    var params = new URLSearchParams(new FormData(form));
    var query = params.toString();
    return query ? action + (action.indexOf('?') === -1 ? '?' : '&') + query : action;
  }

  function initAccountDropdown() {
    document.querySelectorAll('.yt-account-panel').forEach(function (panel) {
      panel.addEventListener('click', function (event) {
        var link = event.target.closest('a[href]');
        if (!link || !panel.contains(link)) return;

        var href = link.getAttribute('href');
        if (!href || href === '#' || href.indexOf('javascript:') === 0) return;

        event.preventDefault();
        openInNewTab(link.href);
      });

      panel.querySelectorAll('.yt-account-panel__email-form').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var url = buildFormUrl(form);
          if (url) openInNewTab(url);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccountDropdown);
  } else {
    initAccountDropdown();
  }
})();
